export default __webpack_public_path__ + "static/media/snail-highlight.bc5f037c.svg";